import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import { ButtonWithIcon } from '@els/els-react--button';
import noop from 'lodash/noop';
import HoverTooltip from '@Components/HoverTooltip';
import { TooltipConstants } from '@Components/InfoTooltip';

import { isOptionChecked } from '../processOptionsUtils';

import './BasicContent.scss';

export default class BasicContent extends React.PureComponent {
  render() {
    const { basicContentDatabases, alertFormDatabases, toggleAlertFormDatabase } = this.props;

    return (
      <div className="create-alert-dialog-section create-alert-dialog-section-basic-content">
        <div className="create-alert-dialog-flex-row">
          <h4 className="create-alert-dialog-section-label">BASIC ALERT CONTENT:</h4>
          <HoverTooltip
            id={TooltipConstants.ids.AlertCreateDialog}
            trigger="click"
            tooltip="Basic alert content is available for customers who have their content integrated into Reaxys (for Reaction based alerts only). The alert email will contain a link to view the results in Reaxys but not show a preview of the results within the email itself">
            <ButtonWithIcon
              iconOnly
              type="link"
              linkIconSize="s"
              size="small"
              data-e2e="info-tooltip-alert-basic-content"
              className="u-els-margin-left-1o2"
              sprite="InformationOutlineCircle"
              onClick={noop}
              a11y={{ name: 'Basic alert content info', description: 'Basic alert content information' }}>
              basic alert info
            </ButtonWithIcon>
          </HoverTooltip>
        </div>
        <fieldset className="create-alert-dialog-fieldset">
          <legend className="sr-only">From databases</legend>
          <div className="create-alert-dialog-row create-alert-dialog-row-databases">
            <div className="create-alert-dialog-column-label" aria-hidden>
              From databases:
            </div>
            <div className="create-alert-dialog-column-content">
              <div className="create-alert-dialog-databases-row">
                {basicContentDatabases.map((database) => (
                  <Checkbox
                    key={database.value}
                    className="create-alert-dialog-database"
                    label={database.label}
                    checked={isOptionChecked(database.value, alertFormDatabases)}
                    onChange={() => {
                      toggleAlertFormDatabase(database.value);
                    }}
                    title={`Select ${database.label}`}
                    data-e2e={`create-alert-database-${database.value}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    );
  }
}

BasicContent.propTypes = {
  basicContentDatabases: PropTypes.array.isRequired,
  alertFormDatabases: PropTypes.array.isRequired,
  toggleAlertFormDatabase: PropTypes.func.isRequired,
};
